module.exports = __webpack_public_path__ + "img/10.8665d876.png";